import React, { useEffect } from 'react';
import { Form, FormInstance, SelectBooleanInput } from 'blueprint-form';
import { Row, Col } from '../../../../grid';
import { CardBlock } from '../../../organisms/card';

interface EpxPreDiabetesSettingsData {
  alerts?: boolean;
  alertAfterHour?: boolean;
}

const DefaultSettings: EpxPreDiabetesSettingsData = {
  alerts: true,
  alertAfterHour: false
};

interface EpxPreDiabetesSettingsProps {
  setForm?: (form: FormInstance<EpxPreDiabetesSettingsData>) => void;
  onSubmit?: (data: EpxPreDiabetesSettingsData) => void;
  disabled?: boolean;
}

const EpxPreDiabetesSettings = ({
  setForm,
  onSubmit: _onSubmit,
  disabled
}: EpxPreDiabetesSettingsProps): JSX.Element => {
  const form = new FormInstance<EpxPreDiabetesSettingsData>(DefaultSettings);
  useEffect(() => {
    if (setForm) {
      setForm(form);
    }
  }, []);
  const onChange = (data: EpxPreDiabetesSettingsData): void => {
    form.setData(data);
  };
  const onSubmit = (data: EpxPreDiabetesSettingsData): void => {
    _onSubmit(data);
  };
  return (
    <CardBlock bare>
      <Form form={form} onChange={onChange} onSubmit={onSubmit}>
        <CardBlock>
          <Row>
            <Col sm={12}>
              <SelectBooleanInput
                label="Enable Alerts for Patient"
                name="alerts"
                fill
                disabled={disabled}
              />
            </Col>
            {/* <Col sm={12}> Hidden for now per Alex's comment
              <SelectBooleanInput
                label="Inform Business Hour"
                name="alertAfterHour"
                fill
                disabled={disabled}
              />
            </Col> */}
          </Row>
        </CardBlock>
      </Form>
    </CardBlock>
  );
};

export default EpxPreDiabetesSettings;
